import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-md"
      >
        <h1 className="text-8xl font-serif text-gradient-gold mb-4">404</h1>
        <h2 className="text-2xl font-serif mb-4">{t.notFound.title}</h2>
        <p className="text-muted-foreground mb-8">{t.notFound.description}</p>
        <Button variant="bronze" size="lg" asChild>
          <Link to="/">
            <Home className="w-5 h-5" />
            {t.notFound.returnHome}
          </Link>
        </Button>
      </motion.div>
    </div>
  );
};

export default NotFound;
